import { formatBirthdayForData, formatBirthdayForDisplay } from '@/modules/localization';
import { User } from '@/types/user';

import { OnboardingDataDraft } from '../types/onboardingDataDraft';

export const mapUserDataToDraft = (userData?: User): Partial<OnboardingDataDraft> => {
  return {
    firstName: userData?.firstName ?? '',
    lastName: userData?.lastName ?? '',
    email: userData?.email ?? '',
    phone: userData?.phone ?? '',
    birthday: formatBirthdayForDisplay(userData?.customerProfile?.birthday ?? ''),
    dateOfBirth: formatBirthdayForData(userData?.customerProfile?.birthday),
    terms: userData?.customerProfile?.termsAndConditionsAccepted ?? false,
    consent: userData?.customerProfile?.informedConsentAccepted ?? false,
    sms: userData?.customerProfile?.smsAllowed ?? false,
    userUuid: userData?.uuid ?? '',
    // Use the backend's authoritative flag rather than an email-substring
    // heuristic, which misclassifies real users (testimony@, tester.smith@).
    isTester: userData?.isTester ?? false,
  };
};
